import {createSelector} from 'reselect';

import type {Post} from '@mattermost/types/posts';

import type {GlobalState} from 'types/store';

import {type UserThreadSynthetic, UserThreadType} from '@mattermost/types/threads';

import {selectThreadById} from './select_thread_by_id';

export const selectThreadOrSyntheticThread = createSelector(
    (state: GlobalState, rootPost: Post) => selectThreadById(state, rootPost.id),
    (_: GlobalState, rootPost: Post) => {
        return {
            id: rootPost.id,
            type: UserThreadType.Synthetic,
            reply_count: rootPost.reply_count,
            participants: rootPost.participants,
            last_reply_at: rootPost.last_reply_at ?? 0,
            last_viewed_at: 0,
            is_following: rootPost.is_following ?? null,
            post: {
                user_id: rootPost.user_id,
                channel_id: rootPost.channel_id,
            },
        } as UserThreadSynthetic;
    },
    (selectedThread, syntheticThreadFromPost) => {
        return selectedThread || syntheticThreadFromPost;
    },
);
